import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import MoviesPage from "./pages/MoviePage";
import PoliticsPage from "./pages/PoliticalPage";
import ArticleDetail from "./pages/ArticleDetail";
import UploadArticlsel from "./pages/UploadArticlse";
import Reviews from "./pages/Reviews";
import Collections from "./pages/Collections";
import OttPage from "./pages/OttPage";

// If you have Contact and Feedback pages not yet created, you can create simple placeholders
function Placeholder({title}) { return <div className="container mt-5"><h1>{title}</h1><p>Coming soon...</p></div>; }

function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Navbar />
        <div className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/movies" element={<MoviesPage />} />
            <Route path="/politics" element={<PoliticsPage />} />
            <Route path="/articles/:category" element={<MoviesPage />} />
            <Route path="/article/:id" element={<ArticleDetail />} />
            <Route path="/uploadarticles" element={<UploadArticlsel />} />
            <Route path="/Reviews" element={<Reviews/>} />
            <Route path="/Collections" element={<Collections/>} />
            <Route path="/ott" element={<OttPage/>} />
            <Route path="/contact" element={<Placeholder title="Contact Us" />} />
            <Route path="/feedback" element={<Placeholder title="Feedback" />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
